import { Flex, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { formatDepositCurrencyAmount } from '../../../../../../utils/depositInvoices/formatDepositCurrencyAmount'
import { useDepositInvoiceForm } from '../../../../contexts/depositInvoiceDetailsFormContext'
import { useDepositInvoiceDetailsModal } from '../../../../contexts/depositInvoiceDetailsModalContext'

export const DepositInvoiceDetailsQuoteAmount = (): ReactElement => {
  const { t } = useTranslation()
  const { quoteAmount } = useDepositInvoiceForm()
  const { quoteCurrency, quoteLocale } = useDepositInvoiceDetailsModal()

  return (
    <Flex flexDirection="column">
      <Text variant="h2" weight="semiBold">
        {formatDepositCurrencyAmount(quoteAmount, quoteCurrency, quoteLocale)}
      </Text>
      <Text variant="bodyMD" weight="regular">
        {t('external_invoices.deposit_invoice_details_modal.quote_total_excl_vat')}
      </Text>
    </Flex>
  )
}
